module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "label": "Tags with 3 characters"
    }
  }, [_c('b-taginput', {
    attrs: {
      "before-adding": _vm.beforeAdding
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d50e3eb6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/taginput/examples/ExValidation.vue
// module id = 1265
// module chunks = 7 71